import {Card} from "../../../../../../../components/card/card.jsx";
import WorkScheduleTeamsTable from "./components/work-schedule-teams-table.jsx";
import InputForm from "../../../../../../../components/input/input-form.jsx";
import React, {useCallback, useContext, useState} from "react";
import InputDateTime from "../../../../../../../components/input/input-datetime.jsx";
import Button from "../../../../../../../components/button/button.jsx";
import WorkScheduleWeekPreview from "./components/work-schedule-week-preview.jsx";
import {WorkScheduleContext} from "./context/work-schedule-context.jsx";
import Loader from "../../../../../../../components/template/loader.jsx";
import projectUtils from "../../../../../../../utils/project-utils.js";
import WorkScheduleService from "../../../../../../../services/web/work-schedule-service.js";
import {navigateHook} from "../../../../../../../hooks/use-navigate.js";
import {AlertMessages, getEndOfDay, getStartOfDay} from "../../utils/work-schedule-utils.js";
import {add} from "date-fns";


const WorkScheduleFormCreate = () => {
    const navigate = navigateHook();
    const [isLoading, setIsLoading] = useState(false);
    const {startDate, setStartDate, endDate, setEndDate, teamsToSend, name, setName} = useContext(WorkScheduleContext);



    const handleDate = useCallback((value, field) => {
        if(field === "startDate"){
            setStartDate(value);
            setEndDate(null)
        }
        else {
            setEndDate(value);
        }
    }, []);

    const save = async () => {
        setIsLoading(true)

        const dataToSend = {
            name: name,
            teams: teamsToSend,
            startPeriod: getStartOfDay(startDate).toISOString(),
            endPeriod: getEndOfDay(endDate).toISOString(),
            status: 'PENDING'
        };

        await WorkScheduleService.save(dataToSend).then(({ data }) => {
            projectUtils.success(true)
            if (data.hasConflict) {
                navigate(`/work-schedule/conflicts/${data.id}`, false)
            } else {
                navigate(`/work-schedule/form/${data.id}`, false)
            }
        }).catch(error => {
            console.error(error);

            const { message } = error.response.data;

            let errMessage = AlertMessages[message] ?? "Não foi possível salvar.";
            projectUtils.swalErrorMessage("", errMessage, "Ok");
        }).finally(() => {
                setIsLoading(false)
            }
        )

    }

    const todayMidnight = new Date();
    todayMidnight.setHours(0,0,0)

    return (
        <>
            {isLoading && <Loader/>}
            <Card>
                <Card.Header>
                    <Card.Title>
                        Dados
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className="grid grid-cols-4 gap-2">
                        <div className="col-span-2">
                            <InputForm id="name" name="name" value={name} onChange={({target}) => setName(target.value)}
                                       label="Nome *"/>
                        </div>
                        <div className="col-span-1">
                            <InputDateTime
                                id="startDate"
                                label="Data inicial *"
                                name="startDate"
                                dateFormat="L"
                                selected={startDate ? startDate : undefined}
                                onChange={(value) => handleDate(value, "startDate")}
                                restrictions={{before: todayMidnight}}
                            />
                        </div>
                        <div className="col-span-1">
                            <InputDateTime
                                id="endDate"
                                label="Data final *"
                                name="endDate"
                                dateFormat="L"
                                selected={endDate ? endDate : undefined}
                                onChange={(value) => handleDate(value, "endDate")}
                                disabled={!startDate}
                                restrictions={{before: startDate? add(startDate, {days: 1}): undefined}}
                            />
                        </div>
                    </div>
                </Card.Body>
            </Card>
            <div className="mt-2 flex gap-2 h-[calc(100vh-225px)]">
                <Card className="min-w-[44vw] h-full bg-blue-600">
                    <Card.Header>
                        <Card.Title>
                            Equipes disponíveis
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="overflow-y-auto h-[calc(100%-40px)]">
                        <WorkScheduleTeamsTable/>
                    </Card.Body>
                </Card>
                <Card className="flex-1 min-w-0 h-full">
                    <Card.Header>
                        <Card.Title>
                            Pré-visualização
                        </Card.Title>
                    </Card.Header>
                    <Card.Body className="overflow-y-auto h-[calc(100%-40px)]">
                        <WorkScheduleWeekPreview/>
                    </Card.Body>
                </Card>
            </div>
            <Card className="mt-2">
               <Card.Body className="w-full flex flex-row justify-end gap-2">
                   <Button target="primary" onClick={save} disabled={teamsToSend.length === 0} actionFeedbackType='save'>Salvar</Button>
               </Card.Body>
            </Card>
        </>
    )
}

export default WorkScheduleFormCreate;